var openModal = function () {
    var modal = $('.modal.special-offers:not([data-modal])');

    if (modal.length > 0 && !sessionStorage.getItem('modal')) {

        var timeout = (modalOptions.timeout > 0) ? modalOptions.timeout : 2000;

        setTimeout(function () {

            $('body').addClass('fixed');

            modal.removeClass('hide').one(transitionEvent, function () {
                modal.find('.modal-wrap').removeClass('hide');
            })

        }, timeout);

        sessionStorage.setItem('modal', true);
    } else {
        $('.special-offer').addClass('active');
        $('.call-offer').addClass('active');
    }

};

// CLOSE MODAL

var closeModal = function () {
    var modal = $('.modal:not(.hide)');

    if (modal.length > 0 && !(modal.hasClass('hide'))) {
        modal.find('.modal-wrap').addClass('hide').one(transitionEvent, function () {
            modal.addClass('hide');
            $('.special-offer').addClass('active');
            $('.call-offer').addClass('active');
        })
    }

    $('body').removeClass('fixed');
};

// Animate homepage house selector
var animateSelector = function () {
    var interactive = $('.layer.floor-selector'),
        floorsSelect = interactive.find('svg a');

    var floors = 10;
    for (a = 0; a < floors; a++) {
        (function (index) {
            setTimeout(function () {
                floorsSelect.siblings('[data-floor="' + index + '"]').removeClass('active');
                floorsSelect.siblings('[data-floor="' + (parseInt(index) + 1) + '"]').addClass('active');
            }, 250 * a);
        })(a);
    }
};


$('.modal').on('click', function (e) {
    if ($(e.target).hasClass('close') || !($(e.target).closest('.modal-wrap').length > 0)) {
        closeModal();
    }
});

if (window.innerWidth <= 991) {
    var mobile = $('.homepage-fold-image').attr('data-image-mobile');
    $('.homepage-fold-image').attr('href', mobile);
} else {
    var desktop = $('.homepage-fold-image').attr('data-image-desktop');
    $('.homepage-fold-image').attr('href', desktop);
}

//Other projects carousel
if ($('#projectCarousel').length > 0) {

    var prevArrow = $('.swiper-nav .investors-next .next-arrow');
    var nextArrow = $('.swiper-nav .investors-prev .prev-arrow');

    var projectCarousel = new Swiper('#projectCarousel', {
        slidesPerView: 3,
        spaceBetween: 50,
        centerInsufficientSlides: true,
        touchRatio: 1,
        navigation: {
            nextEl: nextArrow,
            prevEl: prevArrow,
        },
        breakpoints: {
            1000: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            580: {
                slidesPerView: 1.4,
                spaceBetween: 20
            },
        },
    });
}

// TRIGGER FUNCTIONS ON WINDOW LOAD

var onLoad = function (event) {
    // HANDLE MODAL

    openModal();
    animateSelector();
    onResize();

    if ($('body').hasClass('page-template-template-stage-3')) {
        $('li[data-stage="3"]').click();
    }

    // INIT POWERTIP FLOORS

    var floorSelector = $('.fold.selector .floor-selector');

    if (typeof powertips !== 'undefined' && powertips.length > 0) {

        for (var a = 0; a < powertips.length; a++) {

            var blockKey = powertips[a].blockKey,
                floorKey = powertips[a].floorKey,
                tooltipHtml = powertips[a].tooltipHtml;
            floorSelector.find('.' + blockKey + '.' + floorKey).data('powertip', tooltipHtml).addClass('has-powertip');
        }
    }

    $('nav').find('.menu-item').click(function (el) {
        el.preventDefault();
        event.preventDefault();
        let hash = el.target.hash;

        console.log(hash.length);
        let $target = $(hash);

        if($target.length) {
            $('html, body').animate({
                scrollTop: $target.offset().top
            }, 1000);
        }
        return false;
    });

    var availableFloors = floorSelector.find('.has-powertip');

    if (availableFloors.length) {

        availableFloors.powerTip({
            followMouse: true,
            offset: 20,
            manual: true,
            fadeInTime: 0,
            fadeOutTime: 0,
            closeDelay: 0,
            intentPollInterval: 0,
            // smartPlacement: true,
            placement: 'n',
            popupClass: 'floor-select'

        });

        availableFloors.hover(function () {
            $.powerTip.show(this);
        }, function () {
            $.powerTip.hide(this);
        });
    }

    // INIT POWERTIP FLATS

    var flatSelector = $('.floors-container .swiper-slide svg');

    if (typeof floorTooltips !== 'undefined' && floorTooltips.length > 0) {

        for (var a = 0; a < floorTooltips.length; a++) {

            var apartmentKey = floorTooltips[a].apartmentKey,
                tooltipHtml = floorTooltips[a].tooltipHtml;

            // console.log(powerTipFloorJson[a].floor);

            flatSelector.find('.' + apartmentKey).data('powertip', tooltipHtml).addClass('has-powertip');
        }

        //console.log(powerTipFloorJson);
    }

    var availableFlats = flatSelector.find('.has-powertip');

    if (availableFlats.length) {

        availableFlats.powerTip({
            followMouse: true,
            offset: 20,
            manual: true,
            fadeInTime: 0,
            fadeOutTime: 0,
            closeDelay: 0,
            intentPollInterval: 0,
            // smartPlacement: true,
            placement: 'n',
            popupClass: 'flat-select'

        });

        availableFlats.hover(function () {
            $.powerTip.show(this);
        }, function () {
            $.powerTip.hide(this);
        });
    }

    // INIT POWERTIP PARKING
    var parkingSelector = $('.parking-plans .swiper-slide svg');

    if (typeof parkingTooltips !== 'undefined' && parkingTooltips.length > 0) {

        for (var a = 0; a < parkingTooltips.length; a++) {
            var apartmentKey = parkingTooltips[a].apartmentKey,
                tooltipHtml = parkingTooltips[a].tooltipHtml;

            // console.log(powerTipFloorJson[a].floor);

            parkingSelector.find('.' + apartmentKey).data('powertip', tooltipHtml).addClass('has-powertip');
        }

        //console.log(powerTipFloorJson);
    }
    var availableParking = parkingSelector.find('.has-powertip');
    if (availableParking.length) {

        availableParking.powerTip({
            followMouse: true,
            offset: 20,
            manual: true,
            fadeInTime: 0,
            fadeOutTime: 0,
            closeDelay: 0,
            intentPollInterval: 0,
            smartPlacement: true,
            placement: 'n',
            popupClass: 'parking-select'

        });
        if($(window).width() > 1024) {
            availableParking.hover(function () {
                $.powerTip.show(this);
            }, function () {
                $.powerTip.hide(this);
            });
        } else {
            availableParking.click(function () {
                $.powerTip.hide();
                $.powerTip.show(this);
            });
            $(window).on('scroll', function (){
                $.powerTip.hide();
            });
        }

    }

};

$(document).ready(function () {
    // Scroll to middle of floor selection on mobile
    if ($(window).width() <= 1030) {

        if ($('.layer.floor-selector').hasClass('stage-2')) {
            var scrollWidth = $('.layer.floor-selector.stage-2').innerWidth();
            $('.layer.floor-selector.stage-2').animate({scrollLeft: scrollWidth}, 300);
        } else {
            var scrollWidth = $('.layer.floor-selector').innerWidth() / 2;
            $('.layer.floor-selector').animate({scrollLeft: scrollWidth}, 300);
        }
    }

    // Scroll to Contact form
    if ($('#to-contact-form').length > 0) {
        $('#to-contact-form').on('click', function () {
            $('body').addClass('fixed');

            $('.modal.special-offers').removeClass('hide').one(transitionEvent, function () {
                $('.modal.special-offers').find('.modal-wrap').removeClass('hide');
            })
            // if($('.section-contacts .form-container').length > 0) {
            //     $('html, body').animate({
            //         scrollTop: $(".section-contacts .form-container").offset().top
            //     }, 1000);
            // }
        });
    }

});

$(window).on('load', onLoad);




var count = 0;
$(document).mouseleave(function () {
    if (count === 0) {
        $('.modal-leave:not(.v2)').removeClass('hide');
        $('.modal-leave:not(.v2)').find('.modal-wrap').removeClass('hide');
        count++;
        document.cookie = 'leaveModal=1;path=/';
    }
});


jQuery(function($) {

    setTimeout(()=>{

        if (!localStorage.getItem('popup-closed')) {
            $(".modal-leave.v2").removeClass("hide");
            $(".modal-leave.v2").find(".modal-wrap").removeClass("hide");
        }
    }, 30000);

    if (localStorage.getItem('popup-closed-date', Date.now()) < Date.now() - 1000 * 60 * 60) {
        localStorage.removeItem('popup-closed-date');
        localStorage.removeItem('popup-closed', 2);

    }

    jQuery(document).on('click touchstart mousedown', '.modal-leave.v2', function() {
        localStorage.setItem('popup-closed-date', Date.now());
        localStorage.setItem('popup-closed', 2);
    });

    jQuery(document).on('click touchstart mousedown', '.modal-leave.v2 .green-link', function() {
        $(".modal-leave.v2").addClass("hide");
        $(".modal-leave.v2").find(".modal-wrap").addClass("hide");

        if ($('#butai').length) {

            $('html, body').stop(1).animate({
                scrollTop: $('#butai').offset().top
            }, 1000);
        }
    });

});